/* Matches our Textline number for patients */
export const TANDEM_PHONE_NUMBER = '8334635013';

/*
 * max width of the body container in desktop view
 * see Banner.tsx, PageContainer.tsx, ModalSheet.tsx
 */
export const BODY_MAX_WIDTH = '35.5em';
